import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Activity } from './components/Activity';
import { Layout } from './components/Layout';
export function AppRouter() {
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={<App data-id="element-5" />} data-id="element-4" />
        <Route path="/activity" element={<Layout data-id="element-7">
              <Activity data-id="element-8" />
            </Layout>} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}